import { version } from '../package.json';
import { EventRank } from 'event-rank';

export default {

  // top level properties
  version,

  // Classes
  EventRank

}
